import axios from "axios";

// In Emergent's deployment platform, the frontend bundle is built with the
// PREVIEW URL baked into REACT_APP_BACKEND_URL — the platform doesn't yet
// rewrite it for custom production domains. If we detect we're running on a
// host that isn't the preview environment and isn't localhost, prefer the
// current origin (the FastAPI backend is served from the same domain via the
// Emergent ingress). This makes the deployed app self-healing across both
// preview AND production environments without manual .env edits.
function resolveBackendUrl() {
  const baked = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window === "undefined") return baked;
  const host = window.location.hostname || "";
  const isPreview = host.includes("preview.emergentagent.com") || host.includes("emergentagent.com");
  const isLocal = host === "localhost" || host === "127.0.0.1";
  if (!isPreview && !isLocal) {
    return window.location.origin;
  }
  return baked;
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sf_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  // Handle full axios error.response.data shape { detail: ... } by recursing
  // into the inner detail — this is FastAPI's standard error envelope.
  if (typeof detail === "object" && "detail" in detail) {
    return formatApiErrorDetail(detail.detail);
  }
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  try {
    return JSON.stringify(detail);
  } catch {
    return "Something went wrong.";
  }
}

export default api;
